import React from 'react';

const IntroStatement = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-kiloterra-dark mb-8 leading-tight uppercase animate-slide-up">
          Earn a multiple six-figure income. <span className="text-kiloterra-yellow">Set your own schedule.</span> Enjoy the Freedom to spend more time outdoors.
        </h2>
        <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-medium">
          A career at KILOTERRA turns your outdoor and land experience into a life-changing career with unlimited growth opportunity.
        </p>
      </div>
    </section>
  );
};

export default IntroStatement;